/// <reference types="next/image-types/global" />
import Image from "next/image";
import mapImage from "@repo/assets/public/map2.png";

interface MapProps {
  text?: string;
  children?: React.ReactNode;
}

export function Map(props: MapProps): React.JSX.Element {
  return (
    <div className="w-full h-full relative">
      <Image
        alt="map"
        className="w-full h-full lg:max-w-[1200px] relative -z-20"
        sizes="100vw"
        src={mapImage}
        width={1200}
      />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full">
        {props.children || props.text}
      </div>
    </div>
  );
}
